import { render } from "./CreatePrSteps.vue?vue&type=template&id=a5c7e128&scoped=true"
import script from "./CreatePrSteps.vue?vue&type=script&lang=js"
export * from "./CreatePrSteps.vue?vue&type=script&lang=js"

import "./CreatePrSteps.vue?vue&type=style&index=0&id=a5c7e128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c7e128"]])

export default __exports__